import * as STD                   from '@emersya/mpa-std';
import * as CM                    from '@emersya/mpa-components-manager';

export interface IDevToolsComponentConfiguration extends CM.Component.IConfiguration {
};
import winCSS                     from './DevTools-window.module.scss';

void winCSS;

export class DevToolsComponent extends CM.Component<
	DevToolsComponent,
	IDevToolsComponentConfiguration
> {
	static count = 0;
	static keyCodeToggleActivation = 'Control+²';
	static keyCodeEnableSelection = 'ShiftLeft';
	static server = location.origin + ':24000';
	// static override isInsertionEnabled = false;
	// private static readonly devToolsSymbol = Symbol('devTools');
	// DOM : HTMLDivElement;
	// win: Window | null = null;
	frame!: FramePopup.Component<any>;
	isInInspectionMode = false;
	private highlighted: CM.DOMComponent<any, any, any> | null = null;
	private inspected: CM.Component<any, any> | null = null;
	private backReferences: Map<
		CM.Component<any, any>, /* Referenced component */
		{ component: CM.Component<any, any>, propertyPath: string }[]>;
	private console!: DevToolsConsole.Component;

	private originalConsoleLog: (...data: any[]) => void = console.log;
	private originalConsoleWarn: (...data: any[]) => void = console.warn;
	private originalConsoleError: (...data: any[]) => void = console.error;

	override async component_onActivationChange(event: STD.events.Event<any, CM.Component<any, any>>) {
		await super.component_onActivationChange(event);
		if (event.subType === 'enabled') {
			// this.frame
			await this.fillUI();
			STD.events.Target.enableDebugAndStrictMode(
				this.console.onEventDispatch.bind(this.console),
				this.console.onEventDispatched.bind(this.console)
			);
			console.log = <any>this.console_log.bind(this);
			console.warn = <any>this.console_warn.bind(this);
			console.error = <any>this.console_error.bind(this);
			// await new Promise(r => setTimeout(r, 100));
			// this.frame.window.moveTo(2500, 0); // Move the window to the right screen
			// await new Promise(r => setTimeout(r, 100));
			// w.moveTo(0, 0); // Laid the window at the top-left of the right screen
			// await new Promise(r => setTimeout(r, 100));
			// w.resizeTo(screen.availWidth, screen.availHeight);
		} else {
			STD.events.Target.disableDebugAndStrictMode();
			console.log = this.originalConsoleLog;
			console.warn = this.originalConsoleWarn;
			console.error = this.originalConsoleError;
		}
	};

	async console_log(...data: any[]) {
		await this.console.onConsoleEvent('log', data);
		this.originalConsoleLog.call(console, ...data);
	}

	async console_warn(...data: any[]) {
		await this.console.onConsoleEvent('warn', data);
		this.originalConsoleWarn.call(console, ...data);
	}

	async console_error(...data: any[]) {
		await this.console.onConsoleEvent('error', data);
		this.originalConsoleError.call(console, ...data);
	}

	toggleInspectionMode(event: STD.events.Event<any, any> | null) {
		if (this.isInInspectionMode) {
			document.body.classList.remove('debugger-inspection');
			event?.target.component_DOM.classList.remove('inInspection');
			this.highlight(null);
			this.inspect(null);
		} else {
			document.body.classList.add('debugger-inspection');
			event?.target.component_DOM.classList.add('inInspection');
		}
		this.isInInspectionMode = !this.isInInspectionMode;
	};

	override async component_finalize() {
		await super.component_finalize();
		const SM = CM.Manager.storeTypes.get('shortcuts-manager');
		if (!SM) {
			this.component_throwUserError('A shortcuts-manager is imperative for the debugger to work!', {});
		}
		const sm = <ShortcutsManager.Component>CM.Manager.storeInstancesByType.get(SM)![0];
		if (!sm) {
			this.component_throwUserError('A shortcuts-manager is imperative for the debugger to work!', {});
		}
		sm.addShortcut({
			type: 'down-up',
			code: DevToolsComponent.keyCodeToggleActivation,
			selectors: ['*'],
			method: {
				type: 'call',
				componentPath: this.component_getPath(),
				propertyPath: 'component_toggleActivation',
				parameters: []
			}
		});
		{
			const f = this.component_find('@:frame');
			if (!(f instanceof FramePopup.Component)) {
				this.component_throwLibraryError('', {
					frame: f
				});
			}
			this.frame = f;
		}
		await (<Image.Component>this.component_find('@:frame.menu.selectComponent.icon')).update(nodeSearchIconDataURL);

		this.console = <DevToolsConsole.Component>this.component_find('@:frame.menu.console.content.console');
	};

	// private async onComponentConfigurationChangeJSON(newJSON : STD.object.JSONComplexRecursive) {
	// 	if (!this.highlighted) {
	// 		return;
	// 	}
	// 	const path = this.highlighted.component_getPath();
	// 	newJSON = Object.assign({}, newJSON);
	// 	console.log('>>', path, newJSON);
	// 	const response = await fetch(DevToolsComponent.server + '/saveComponentConfiguration', {
	// 		method : 'POST',
	// 		cache  : 'no-cache',
	// 		mode   : 'cors',
	// 		body   : JSON.stringify({
	// 			path,
	// 			newJSON
	// 		}),
	// 		headers : {
	// 			'Content-Type' : 'application/json'
	// 		}
	// 	});
	// 	void response;
	// 	console.log('Update saved.');
	// };


	// private onTreeClick(ev : MouseEvent) {
	// 	const t = <HTMLDivElement>ev.target;
	// 	if (!t.details || !t.details.component) {
	// 		return;
	// 	}
	// 	this.highlight(t.details.component);
	// 	this.edit();
	// };


	// private openTreeSection() {
	// 	this.winDOM.classList.remove('configuration');
	// 	this.winDOM.classList.remove('events');
	// 	this.winDOM.classList.remove('errors');
	// 	this.winDOM.classList.add('tree');
	// };


	// private openConfigurationSection() {
	// 	this.winDOM.classList.remove('tree');
	// 	this.winDOM.classList.remove('events');
	// 	this.winDOM.classList.add('configuration');
	// 	const c = this.components.reduce((a, c) => {
	// 		a[ c.getPath() ] = c.configuration;
	// 		return (a);
	// 	}, {} as Record<string, STD.object.JSON>);
	// 	this.configurationEditor.set(c);
	// };


	// private openEventsSection() {
	// 	this.winDOM.classList.remove('tree');
	// 	this.winDOM.classList.remove('configuration');
	// 	this.winDOM.classList.remove('errors');
	// 	this.winDOM.classList.add('events');
	// };


	// private async errorsRefreshList() {
	// 	const listDOM = <HTMLUListElement>this.winDOM.querySelector('.section-errors .list');
	// 	listDOM.textContent = '';
	// 	for (const error of STD.errors.getAll()) {
	// 		const infos = await STD.errors.summarize(error);
	// 		const entriesDesc = [];
	// 		for (const entry of infos) {
	// 			const header = [];
	// 			if (entry?.details?.component) {
	// 				const path = (<CM.Component<any, any>>entry?.details?.component).component_getPath();
	// 				header.push({
	// 					classList  : [ 'component' ],
	// 					text       : path,
	// 					attributes : {
	// 						title : path
	// 					}
	// 				});
	// 			}
	// 			header.push({
	// 				classList : [ 'message' ],
	// 				text : entry.message
	// 			});
	// 			entriesDesc.push({
	// 				classList : [ 'entry' ],
	// 				childs    : [
	// 					{
	// 						classList : [ 'header' ],
	// 						childs    : header
	// 					}, {
	// 						classList : [ 'stacktrace' ],
	// 						childs : [
	// 							{
	// 								text : '+'
	// 							}, {
	// 								text : entry.stacktrace.map(x => x.toString()).join('\n')
	// 							}
	// 						]
	// 					}
	// 				]
	// 			});
	// 			entriesDesc.push({
	// 				classList : [ 'separator' ]
	// 			});
	// 		}
	// 		const desc = STD.DOM.factory({
	// 			tag    : 'li',
	// 			childs : entriesDesc
	// 		});
	// 		listDOM.appendChild(desc);
	// 	}
	// };


	// private async openErrorsSection() {
	// 	this.winDOM.classList.remove('tree');
	// 	this.winDOM.classList.remove('configuration');
	// 	this.winDOM.classList.remove('events');
	// 	this.winDOM.classList.add('errors');
	// 	await this.errorsRefreshList();
	// };


	// private onEventsToolsClearClick() {
	// 	(<any>this.winDOM.querySelector('.section-events .list')).textContent = '';
	// };


	// private async onBeforeUnload() {
	// 	if (this.isStarted) {
	// 		await this.disable();
	// 	}
	// 	return (null);
	// };


	//@ts-ignore: not used
	private async onMouseMove(ev: MouseEvent) {  //eslint-disable-line require-await
		if (this.component_isDisabled || !this.isInInspectionMode) {
			return;
		}
		let t: Element | null = ev.target as Element;
		let component: CM.DOMComponent<any, any, any> | null = null;
		while (t) {
			const k = t as any;
			if (k.details && k.details.component) {
				component = k.details.component;
				break;
			}
			t = t.parentElement;
		}
		this.highlight(component);
	};


	// private onTreeConfigurationButtonClick(ev : MouseEvent) {
	// 	var t = ev.currentTarget;
	// 	var K = (<any>t).parentElement.parentElement;
	// 	K.classList.remove('references');
	// 	K.classList.add('configuration');
	// };


	// private onTreeReferencesButtonClick(ev : MouseEvent) {
	// 	var t = ev.currentTarget;
	// 	var K = (<any>t).parentElement.parentElement;
	// 	K.classList.remove('configuration');
	// 	K.classList.add('references');
	// };

	private async onClick(ev: MouseEvent) {
		if (this.component_isDisabled || !this.isInInspectionMode) {
			return;
		}
		ev.preventDefault();
		ev.stopImmediatePropagation();
		ev.stopPropagation();

		if (this.highlighted) {
			await this.edit(this.highlighted);
		}
	};


	private async edit(component: CM.Component<any, any>) {
		this.inspect(component);

		const configurationJSONEditor = <InputJSON.Component>this.component_find('@:frame.menu:content.components.content.menu:content.configuration.content');
		const referencesBlock = <Block.Component>this.component_find('@:frame.menu:content.components.content.menu:content.references.content');
		STD.DOM.removeAllChild(referencesBlock.component_DOM);

		if (!this.inspected) {
			await configurationJSONEditor.updateValue(null);

		} else {
			await configurationJSONEditor.updateValue(this.inspected.component_configuration);

			const references = this.backReferences.get(this.inspected);

			if (!references) {
				referencesBlock.component_DOM.appendChild(STD.DOM.factory({
					tag: 'p',
					text: 'This component is not referenced anywhere'
				}));

			} else {
				referencesBlock.component_DOM.appendChild(STD.DOM.factory({
					tag: 'table',
					classList: ['references'],
					childs: [
						{
							tag: 'thead',
							childs: [
								{
									tag: 'tr',
									childs: [
										{ tag: 'th', text: 'Component' },
										{ tag: 'th', text: 'Property path' }
									]
								}
							]
						},
						{
							tag: 'tbody',
							childs: references.map(ref => ({
								tag: 'tr',
								childs: [
									{
										tag: 'td',
										childs: [
											{
												tag: 'button',
												text: ref.component.component_getPath(),
												events: {
													click: async () => {
														await this.edit(ref.component);
													}
												}
											}
										]
									},
									{
										tag: 'td',
										text: ref.propertyPath
									}
								]
							}))
						}
					]
				}));
			}
		}
		// (
		// 	<HTMLDivElement>this.winDOM.querySelector('.section-tree > .K > .path')
		// ).textContent = c.component_getPath();
		// const md = <any>c[DevToolsComponent.devToolsSymbol];
		// const refs = md.referencedBy;
		// this.treeEditor.set(c.component_configuration);
		// this.treeReferenceEditor.set(refs);
	};


	private highlight(component: CM.DOMComponent<any, any, any> | null) {
		if (this.highlighted) {
			this.highlighted.component_DOM.classList.remove('debugger-highlight');
		}
		this.highlighted = component;
		if (this.highlighted) {
			this.highlighted.component_DOM.classList.add('debugger-highlight');
		}
	};

	private inspect(component: CM.Component<any, any> | null) {
		this.highlight(null);
		if (this.inspected && this.inspected instanceof CM.DOMComponent) {
			this.inspected.component_DOM.classList.remove('debugger-inspect');
		}
		this.inspected = component;
		if (this.inspected && this.inspected instanceof CM.DOMComponent) {
			this.inspected.component_DOM.classList.add('debugger-inspect');
		}
	};

	private async fillUI() {
		const frame = <FramePopup.Component<any>>this.component_find('@:frame');
		const w = frame.window;
		if (!w) {
			return;
		}
		(<CM.DOMComponent<any, any, any>>this.component_find('@:frame')).component_DOM.appendChild(STD.DOM.factory({
			tag: 'style',
			text: winCSS
		}));

		const menu = <MenuTab.Component>this.component_find('@:frame.menu');
		await menu.open('components');

		const submenu = <MenuTab.Component>this.component_find('@:frame.menu:content.components.content.menu');
		await submenu.open('configuration');

		this.backReferences.clear();

		for (const component of CM.Manager.storeInstances) {
			const references = component.component_findReferencesInConfig();

			for (const reference of references) {
				let backReferences = this.backReferences.get(reference.component);

				if (!backReferences) {
					backReferences = [];
					this.backReferences.set(reference.component, backReferences);
				}

				backReferences.push({
					component,
					propertyPath: reference.propertyPath
				});
			}
		}

		// w.document.body.appendChild(this.winDOM);
		// const componentsTreeDOM = <HTMLDivElement>this.winDOM.querySelector(
		// 	'.section-tree > .tree'
		// );
		// const stack : CM.Component<any, any>[]= [ CM.root ];
		// // const stack = [ ...CM.topLevels ];
		// const allComponents : CM.Component<any, any>[] = [];
		// // this.components = allComponents;
		// while (stack.length) {
		// 	const component = stack.shift() as CM.Component<any, any>;
		// 	allComponents.push(component);
		// 	const DOM = STD.DOM.factory({
		// 		classList : [ 'node' ],
		// 		childs    : [
		// 			{
		// 				classList : [ 'label' ],
		// 				text      : `${ component.id }( ${ component.static.type } )`,
		// 				details   : {
		// 					component
		// 				}
		// 			}, {
		// 				classList : [ 'childs' ]
		// 			}
		// 		]
		// 	});
		// 	if (component.parent) {
		// 		const parentMd = component.parent[ DevToolsComponent.devToolsSymbol ];
		// 		(<any>parentMd).DOM.children[1].appendChild(DOM);
		// 	} else {
		// 		componentsTreeDOM.appendChild(DOM);
		// 	}
		// 	component[ DevToolsComponent.devToolsSymbol ] = {
		// 		DOM,
		// 		referencedBy : {}
		// 	};
		// 	for (let c of component.innerChilds) {
		// 		stack.push(c);
		// 	}
		// 	for (let c of component.outerChilds) {
		// 		stack.push(c);
		// 	}
		// }
		// for (let c of allComponents) {
		// 	const conf = c.configuration as CM.IComponentConfiguration;
		// 	const evs = conf['@listen'] || [];
		// 	for (let ev of evs) {
		// 		for (let cPath of (ev.components || [ ev.component ])) {
		// 			if (!cPath) {
		// 				this.throwUserError('');
		// 			}
		// 			const target = c.find(cPath);
		// 			if (!target) {
		// 				this.throwLibraryError('err', {
		// 					cPath,
		// 					ev,
		// 					allComponents
		// 				});
		// 			}
		// 			const md: any = target[ DevToolsComponent.devToolsSymbol ];
		// 			let mdRefByC = md.referencedBy[ c.getPath() ];
		// 			if (!mdRefByC) {
		// 				mdRefByC = md.referencedBy[ c.getPath() ] = {
		// 					events : {}
		// 				};
		// 			}
		// 			const eventsNames = (
		// 				ev.event ? [ ev.subEvent ? ev.event + '.' + ev.subEvent : ev.event ] :
		// 				(
		// 					(<string[]>ev.events).map(x => (ev.subEvent ? x + '.' + ev.subEvent : x))
		// 				)
		// 			);
		// 			for (let evName of eventsNames) {
		// 				mdRefByC.events[ evName ] = ev.actions;
		// 			}
		// 		}
		// 	}
		// }
		// this.isUsable = true;
	};


	override async component_disable() {
		await super.component_disable();

		if (this.isInInspectionMode) {
			this.toggleInspectionMode(null);
		}
	}

	private async onBeforeUnload() {
		await this.component_disableIfIsEnabled();
	};

	constructor(
		descriptor: ConstructorParameters<typeof CM.Component>[0],
		configuration: IDevToolsComponentConfiguration
	) {
		super(descriptor, configuration);
		if (DevToolsComponent.count++ > 0) {
			this.component_throwUserError('Only one debugger is instantiable!', {});
		}
		this.backReferences = new Map();
		document.addEventListener('mousemove', this.onMouseMove.bind(this));
		document.addEventListener('click', this.onClick.bind(this));
		window.addEventListener('beforeunload', this.onBeforeUnload.bind(this));
		// this.winDOM = STD.DOM.factory<typeof HTMLDivElement>({
		// 	classList : [ 'win' ],
		// 	childs    : [
		// 		{
		// 			classList : [ 'menu' ],
		// 			childs : [
		// 				{
		// 					tag       : 'button',
		// 					classList : [ 'header-tree' ],
		// 					text      : 'Tree',
		// 					events    : { click : this.openTreeSection.bind(this) }
		// 				},
		// 				// {
		// 				// 	tag       : 'button',
		// 				// 	classList : [ 'header-configuration' ],
		// 				// 	text      : 'Configuration',
		// 				// 	events    : { click : this.openConfigurationSection.bind(this) }
		// 				// },
		// 				{
		// 					tag       : 'button',
		// 					classList : [ 'header-events' ],
		// 					text      : 'Events',
		// 					events    : { click : this.openEventsSection.bind(this) }
		// 				}, {
		// 					tag       : 'button',
		// 					classList : [ 'header-errors' ],
		// 					text      : 'Errors',
		// 					events    : { click : this.openErrorsSection.bind(this) }
		// 				}
		// 			]
		// 		}, {
		// 			classList : [
		// 				'section-tree'
		// 			],
		// 			childs    : [
		// 				{
		// 					classList : [ 'tree' ],
		// 					events    : { click : this.onTreeClick.bind(this) }
		// 				}, {
		// 					classList : [ 'K' ],
		// 					childs    : [
		// 						{
		// 							classList : [ 'path' ]
		// 						}, {
		// 							classList : [ 'menu' ],
		// 							childs : [
		// 								{
		// 									tag       : 'button',
		// 									classList : [ 'configuration' ],
		// 									text      : 'Configuration',
		// 									events    : {
		// 										click : this.onTreeConfigurationButtonClick.bind(this)
		// 									}
		// 								}, {
		// 									tag       : 'button',
		// 									classList : [ 'references' ],
		// 									text      : 'References',
		// 									events    : {
		// 										click : this.onTreeReferencesButtonClick.bind(this)
		// 									}
		// 								}
		// 							]
		// 						}, {
		// 							classList : [ 'sections' ],
		// 							childs    : [
		// 								{
		// 									classList : [ 'j-editor' ]
		// 								}, {
		// 									classList : [ 'references' ]
		// 								}
		// 							]
		// 						}
		// 					]
		// 				}
		// 			]
		// 		}, {
		// 			classList : [
		// 				'section-configuration'
		// 			],
		// 			childs : [
		// 				{
		// 					classList : [ 'j-editor' ]
		// 				}
		// 			]
		// 		}, {
		// 			classList : [
		// 				'section-events'
		// 			],
		// 			childs : [
		// 				{
		// 					classList : [ 'tools' ],
		// 					childs : [
		// 						{
		// 							tag    : 'button',
		// 							text   : 'x',
		// 							events : {
		// 								click : this.onEventsToolsClearClick.bind(this)
		// 							}
		// 						}
		// 					]
		// 				},
		// 				{
		// 					tag       : 'ul',
		// 					classList : [ 'list' ]
		// 				}, {
		// 					classList : [ 'details' ]
		// 				}
		// 			]
		// 		}, {
		// 			classList : [
		// 				'section-errors'
		// 			],
		// 			childs : [
		// 				{
		// 					classList : [ 'tools' ],
		// 					childs : [
		// 						{
		// 							tag    : 'button',
		// 							text   : 'x',
		// 							events : {
		// 								// click : this.onEventsToolsClearClick.bind(this)
		// 							}
		// 						}
		// 					]
		// 				},
		// 				{
		// 					tag       : 'ul',
		// 					classList : [ 'list' ]
		// 				}, {
		// 					classList : [ 'details' ]
		// 				}
		// 			]
		// 		}
		// 	]
		// });
		// this.treeEditor = new JE(
		// 	<HTMLDivElement>this.winDOM.querySelector('.section-tree .j-editor'),
		// 	{
		// 		onChangeJSON: STD.misc.createDebouncerPromise({
		// 			fn: this.onComponentConfigurationChangeJSON.bind(this),
		// 			delay: 500
		// 		})
		// 	}
		// );
		// (<any>this.winDOM.querySelector('.menu .header-tree')).click();
	};

};
export namespace NS {
	export const Component = DevToolsComponent;
	export type Component = DevToolsComponent;
	export type Configuration = IDevToolsComponentConfiguration;
}
import './DevTools.scss';
import nodeSearchIconDataURL      from './icons/node_search_icon.svg';
import manifestXMLSource          from './DevTools.xml';
import { NS as FramePopup }       from '../frames/FramePopup/FramePopup';
import { NS as Image }            from '../Image/Image';
import { NS as InputJSON }        from '../inputs/InputJSON/InputJSON';
import { NS as ShortcutsManager } from '../ShortcutsManager/ShortcutsManager';
import { NS as MenuTab }          from '../menus/MenuTab/MenuTab';
import { NS as Block }            from '../Block/Block';
import { NS as DevToolsConsole }  from './DevToolsConsole/DevToolsConsole';

CM.Manager.declare({
	id: 'devTools',
	type: DevToolsComponent,
	manifest: manifestXMLSource
});
